import {
  $get,
  $post
} from './httpRequest'
import axios from 'axios'
var baseurl = '/permissions'
var api = '/applyqrcode'


//后台管理系统  system 接口
//登录
export function adminLogin(params) {
  var url = '/login'
  return $post(url, params)
}

// 获取新闻分页列表
export function getNewsList(params) {
  var url ='/newsIntroduction/getNewsListPage'
  return $post(url, params)
}

// 图片上传
export function uploadImage(params) {
  var url ='/uploadFile'
  return $post(url, params)
}

// 新增新闻资讯
export function saveNewsIntroduction(params) {
  var url ='/newsIntroduction/saveNewsIntroduction'
  return $post(url, params)
}
//修改资讯内容
export function updateNewsIntroduction(params) {
  var url ='/newsIntroduction/updateNewsIntroduction'
  return $post(url, params)
}












// 获取用户导航菜单
export function getUserNavList(params) {
  var url = baseurl + '/systemNavigation/getSystemNavigation'
  return $post(url, params)
}
//获取所有菜单列表
export function getSystemAllNavList(params) {
  var url = baseurl + '/systemNavigation/getSystemNavigationTree'
  return $post(url, params)
}


// WEBPACK FOOTER //
// ./src/common/api.js